import { GetterTree } from 'vuex'

import { AIAssistantState } from './state'

export const getters: GetterTree<AIAssistantState, any> = {
  shouldShowQuestionTypePicker: (state, _getters, _rootState, rootGetters): boolean => {
    const isProtegeAskEnabled = Boolean(rootGetters['user/isProtegeAskEnabled'])
    const isProtegeAskDocEnabled = Boolean(rootGetters['user/isProtegeAskDocEnabled'])

    return (
      isProtegeAskEnabled &&
      isProtegeAskDocEnabled &&
      !state.conversationActiveId &&
      !state.questionType
    )
  },
}
